/** Root-shell integration seam: every Help route uses its own public chrome and must bypass staff-only providers. */
export function isHelpPath(pathname: string): boolean {
  const normalized = pathname.replace(/\/+$/, '') || '/'
  return normalized === '/help' || normalized.startsWith('/help/')
}

/** Staff screenshot bytes are served only by an authenticated API route with `Cache-Control: private, no-store`. */
export function protectedHelpAsset(src: string): string {
  const prefix = '/help/screenshots/'
  if (!src.startsWith(prefix)) return src
  const filename = src.slice(prefix.length)
  if (!/^[a-z0-9-]+\.(?:desktop|phone)\.png$/.test(filename)) return src
  return `/api/v1/help/screenshots/${filename}`
}
